import React from 'react';
import DesktopPDFFormContent from './PDFFormContent';
import withForms from '../../formsCommon/withForms';
import withPDFFormDocument from '../withPDFFormDocument';
import PropTypes from 'prop-types';

class InPagePdfForm extends React.Component {
  render() {
    return (
      <>
        <div className={'inpage-header'}>{this.props.showTitleAndInfo}</div>
        <DesktopPDFFormContent {...this.props} pageReady={true} />
      </>
    );
  }
}

InPagePdfForm.propTypes = {
  formStructure: PropTypes.array,
  showTitleAndInfo: PropTypes.any
};

export default withPDFFormDocument(withForms(InPagePdfForm));
